import { useResolvedAccessLevel } from '../../components/PermissionsContainer';
import { ORDER_LC_FIELDS_COMPONENT_ID } from './useCanEditOrderLcFields';

/**
 * Whether the current user may edit the order's hazmat Y/N flag.
 *
 * The Haz flag is part of the LC-editable field grouping, so it resolves the
 * same `order-lc-fields` component permission as the other LC order fields
 * (Ports / DC / Dept / Drop). Ships **defaultDisabled**: until an admin grants a
 * group edit access on `order-lc-fields`, the flag stays read-only on orders for
 * everyone.
 *
 * This gates two things that must stay in lockstep:
 *   1. the Haz `<FlagInput>`'s `readOnly` on the Order Info tab, and
 *   2. the Rule 6 hazmat save-block in `validateOrderSave` ("Hazmat class + UN
 *      required when hazmat is Y") — V1 only enforced it for users with write
 *      access to the hazmat field, so read-only users are never blocked.
 *
 * Note: this is the ORDER gate. Template hazmat-flag editability is handled by
 * the template-edit gate via `canEditLc('hazmat')` in the view; the Rule 6 block
 * was off for everyone before this and remains order-scoped here.
 */
export const useCanEditHazmat = (): boolean =>
  useResolvedAccessLevel(ORDER_LC_FIELDS_COMPONENT_ID, false, true) >= 2;
